/**
 * orders an array using lodash
 * https://lodash.com/docs/4.17.5#orderBy
 */

import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash-es';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {
  transform: (value: any, args?: any) => any = orderBy;
}
